const AUTH_REQUESTS = ['token/invalidate', 'token/refresh', 'login', 'user/me']

export default function ({ app, redirect }) {
  app.$axios.onError(async error => {
    const code = parseInt(error.response && error.response.status)
    const originalRequest = error.config;
    const url = originalRequest?.url

    if (!AUTH_REQUESTS.includes(url) && code === 401) {
      if (!originalRequest.isRetry) {
        console.log(`Axios: 401 - must to refresh token. URL: ${url}`)

        originalRequest.isRetry = true

        try {
          await app.$auth.refreshTokens()

          console.log('Axios: refreshed successfully')

          return app.$axios(originalRequest)

        }
        catch (err) {
          console.log('Axios: refresh crushed, need to logout')

          app.$auth.logout()
          redirect('/login')
        }

      } else {
        console.log('Axios: retry crushed, need to logout')

        app.$auth.logout()
        redirect('/login')
      }
    } else {
      return Promise.reject(error);
    }
  })
}